import React from "react";
const PluginsContext = React.createContext(null);
const PluginsContextProvider = ({ plugins, children }) => /* @__PURE__ */ React.createElement(PluginsContext.Provider, { value: plugins }, children);
export {
  PluginsContext,
  PluginsContextProvider
};
//# sourceMappingURL=PluginsContext.js.map
